import React, { FC } from 'react';

import { useActionsDispatcher } from '../../../../../../ActionsDispatcher';
import { useUtils } from '../../../../../../UtilsProvider';

import type { MobileToolsProps } from './MobileTools.types';

export const MobileTools: FC<MobileToolsProps> = ({ section }) => {
  const { MobileToolsPanel } = useUtils();
  const { dispatchOpenLeftbarSidePanelAction } = useActionsDispatcher();

  const openLeftbarSidePanel = (comp: React.ReactNode) =>
    dispatchOpenLeftbarSidePanelAction({ sideBarComponent: comp });

  return <MobileToolsPanel openLeftbarSidePanel={openLeftbarSidePanel} />;
};
